import styled from 'styled-components';

const SearchBarStyled = styled.form`
  position: relative;
  display: flex;
  width: 100%;

  .SearchBar {
    &__dropdown {
      display: flex;
      flex: 1;
    }

    &__wrapper {
      position: relative;
      display: flex;
      background-color: #fafafa;
      flex: 1;
      width: 100%;
    }

    &__input {
      border: none;
      padding: 12px 8px;
      background-color: #fafafa;
      flex: 1;
      font-family: inherit;

      &:focus {
        outline: none;
      }
    }

    &:focus {
      outline: none;
    }

    &__btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 28px;
      background-color: #fafafa;
      box-shadow: none;
      outline: none;
      border: none;
      padding: 0;

      & > .Button__loading {
        stroke: #000000;
        padding-left: 8px;
      }
    }

    &__btn-search {
      padding-left: 8px;
    }

    &__btn-cross {
      padding-right: 8px;
      right: 8px;
      height: 100%;
      display: flex;
      align-items: center;
    }

    &__btn-container {
      width: 36px;
    }
  }
`;

export { SearchBarStyled as default };
//# sourceMappingURL=bundle.esm3.js.map
